import { render } from "./EspecialBotton.vue?vue&type=template&id=7f5f4e4b&scoped=true"
import script from "./EspecialBotton.vue?vue&type=script&lang=js"
export * from "./EspecialBotton.vue?vue&type=script&lang=js"

import "./EspecialBotton.vue?vue&type=style&index=0&id=7f5f4e4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5f4e4b"]])

export default __exports__